// **************************
// *** AgendamentosConcluidos concluidos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 17/06/24 | 15:02h
// *** 4/7/24 | 09h39 → acrescentado o token criptografado
// *** 4/10/24 | 13h13 → acrescentado colaboradores
// **************************



import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
// import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import PCMenu from "../../Components/Menu/pc_menu.jsx";
import CardAgendamentos from '../../../AgendexPrestador/Components/Agendamentos/p_agendamentos.jsx';
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";
import handleApiError from '../../../../Services/apiErrorHandler.js';

import './pc_agendamentos.css';
import { AutoLogout } from "../../../../Services/autologout.js";
import { pc_getUserData } from "../../Services/pc_userutils.js";

function PCAgendamentosConcluidos() {
    const tokenASW = localStorage.getItem("tokenasw");
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const initialUserData = pc_getUserData();
    const tipoAtendimento = 1;
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // id_usuario logado 23/9/24w
    const [id_colaborador, setId_colaborador] = useState(initialUserData.colaboradorId); // id_usuario logado 23/9/24w
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.TAMANHO_PAGINA); // id_usuario logado 23/9/24w
    const [nenhumAgendamentoEncontrado, setNenhumAgendamentoEncontrado] = useState(false);

    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        atualizarAgendamentosColaborador(id_colaborador, pagina);
    }, [id_colaborador, pagina]);

    // tipoAtendimento === 1 (busca agendamentos dos colaboradores) 23/9/24w
    const atualizarAgendamentosColaborador = async (id_colaborador, pagina) => {
        // console.log('atualizando após exclusão / id_col , pag', id_colaborador, pagina);
        setLoading(true);
        setAgendamentos([]);
        const url = `reserva/listarColaboradorWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=2&id_status2=5&token=${tokenASW}&id_colaborador=${id_colaborador}`;
        try {
            const response = await apiaxios.get(url);
            // setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento concluído, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    // console.log(`response data ao trocar colaborador: ${id_colaborador} `, response.data);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleAvaliar = async (agendamento) => {
        const { ID_RESERVA, ID_EMPRESA, NOME, DESCRICAO } = agendamento;
        
        // Primeira requisição para buscar as avaliações do prestador
        try {
            const response = await apiaxios.get(`/reserva/avaliacaoWeb?id_usuario=${ID_EMPRESA}&tipo_avaliacao=P`);
            const { avaliacao, quantidade, retorno } = response.data;
    
            if (retorno !== 'OK') {
                Swal.fire('Erro', retorno, 'error');
                return;
            }
    
            let selectedRating = 0;
    
            MySwal.fire({
                title: 'Qual nota você daria para este Prestador de Serviços?',
                html: `
                    <p>${NOME} (ID Reserva: ${ID_RESERVA})</p>
                    <p>${DESCRICAO}</p>
                    <div id="rating" style="display: flex; justify-content: center;">
                        ${[1, 2, 3, 4, 5].map(i => `<i class="fa fa-star" data-value="${i}" style="cursor: pointer; font-size: 2em; margin: 0 5px;"></i>`).join('')}
                    </div>
                    <p>${quantidade > 0 ? `${quantidade} avaliação${quantidade > 1 ? 's' : ''}` : 'Prestador ainda não foi avaliado. Você é o primeiro cliente a fazê-lo!'}</p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Enviar Avaliação',
                cancelButtonText: 'Voltar',
                didOpen: () => {
                    const stars = MySwal.getPopup().querySelectorAll('.fa-star');
                    stars.forEach(star => {
                        star.addEventListener('click', (e) => {
                            selectedRating = parseInt(e.target.getAttribute('data-value'));
                            stars.forEach(s => s.style.color = s.getAttribute('data-value') <= selectedRating ? 'gold' : 'gray');
                        });
                    });
                },
                preConfirm: () => {
                    if (selectedRating === 0) {
                        Swal.showValidationMessage('Por favor, selecione uma nota antes de enviar.');
                        return false;
                    }
                    return selectedRating;
                }
            }).then(result => {
                if (result.isConfirmed) {
                    // Segunda requisição para enviar a avaliação
                    const id_usuario = JSON.parse(localStorage.getItem("tokenacw")).id_usuario;
    
                    apiaxios.get(`/reserva/avaliarWeb?id_usuario=${id_usuario}&id_reserva=${ID_RESERVA}&tipo_avaliacao=C&avaliacao=${result.value}`)
                        .then(response => {
                            if (response.status === 200 && response.data.retorno === "OK") {
                                Swal.fire('Sucesso', 'Avaliação enviada com sucesso!', 'success');
                                // Atualize a interface conforme necessário
                            } else {
                                Swal.fire('Erro', response.data.retorno || 'Erro ao enviar avaliação', 'error');
                            }
                        })
                        .catch(error => {
                            Swal.fire('Erro', 'Erro ao enviar avaliação: ' + error, 'error');
                        });
                }
            });
        } catch (error) {
            Swal.fire('Erro', 'Erro ao buscar avaliações: ' + error, 'error');
        }
    };
    


    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <PCMenu page="agendamentosconcluidos" />
                        </div>
                        <div className="col py-2 me-3">

                            <div className="form-group">
                                <h1 className="text-center">Agendamentos Concluídos / Colaborador</h1>
                                <hr />

                                <div className="row">
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumAgendamentoEncontrado ? (
                                        <div className="alert alert-danger mt-10" role="alert">
                                            Nenhum "Agendamento Concluído" disponível neste momento...
                                        </div>
                                    ) : (
                                        <div className="box-agendamentos">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Id.Reserva</th>
                                                        <th>Descrição</th>
                                                        <th>Nome Cliente</th>
                                                        <th>Fone Cliente</th>
                                                        <th>Data</th>
                                                        <th>Hora</th>
                                                        <th>Valor</th>
                                                        <th>Desconto</th>
                                                        <th>Valor Total</th>
                                                        <th>Nome Colaborador</th>
                                                        <th className="text-right">Status</th>
                                                        <th className="text-right">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {console.log(agendamentos)} */}
                                                    {agendamentos.map((agendamento, index) => (
                                                        <CardAgendamentos
                                                            key={`${agendamento.ID_RESERVA}-${index}`}
                                                            agendamento={{
                                                                agendamento_id: agendamento.ID_RESERVA,
                                                                agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                agendamento_vr: agendamento.VALOR || 'Vr indisponível',
                                                                agendamento_desc: agendamento.DESCONTO || 'R$ 0,00',
                                                                agendamento_vrtot: agendamento.VALORTOTAL || 'Vr Tot indisponível',
                                                                agendamento_nome_colaborador: agendamento.COL_NOME || 'Colaborador indisponível',
                                                                agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                            }}
                                                            showExcluir={false}
                                                            showAvaliar={false}
                                                            showMotivo={false}
                                                            showMudarStatus={false}
                                                            tipoAtendimento={tipoAtendimento}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                {hasMore && (
                                    <div className="load-more">
                                        <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PCAgendamentosConcluidos;